import type { PermissionGated } from 'src/interfaces/internalAccess'
import { hasAnyPermission } from './hasAnyPermission'

/** Where an app's index route sends someone: the first rail item they may open, if any. */
export const resolveFirstAccessiblePath = <Item extends PermissionGated & { to: string }>(
  items: Item[],
  permissions: string[],
): string | null => {
  const firstAccessible = items.find((item) => {
    return hasAnyPermission(permissions, item.requiredAnyPermission)
  })

  return firstAccessible ? firstAccessible.to : null
}
